import React, { useState, useEffect } from "react";
import api from  "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import ListaOcorrenciaAvaliacao from "../../Componentes/ListaOcorrenciaAvaliacao"
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

import "./styles.css";

const Ocorrencia = () => {
  const [dadosOcorrencias, setdadosOcorrencias] = useState([]);
  const navigate = useNavigate();

  useEffect(function () {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }
    carregaListaOcorrencias();

    const intervaloMenu = setInterval(() => {
      carregaListaOcorrencias();
    }, 60000); // 300000 5 minutos
    return () => clearInterval(intervaloMenu);

  }, []);


  async function carregaListaOcorrencias() {
    let retorno = await buscaOcorrencias();

    if (retorno && retorno.data) {
      let lista = retorno.data[0] || [];

      // Buscar detalhes de cada visita em paralelo
      const detalhadas = await Promise.all(
        lista.map(async (ocorrencia) => {
          try {
            const respDetalhes = await api.get(`/itensocorrencia/${ocorrencia.IDvisita}`);
            if (respDetalhes.data && respDetalhes.data[0]) {
              return {
                ...ocorrencia,
                registro: respDetalhes.data[0].registro // substitui pelo detalhado
              };
            }
            return ocorrencia; // fallback
          } catch (err) {
            console.error("Erro ao buscar produtos detalhados:", err);
            return ocorrencia;
          }
        })
      );
      setdadosOcorrencias(detalhadas);
    } else {
      setdadosOcorrencias([]);
    }
  }


  async function buscaOcorrencias(){          
    try {
      const response = await api.get('/ocorrencia/avaliacao');
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }


  return (
    <div className="menu-container-menu">

      <MenuLateral/>

      <div id="painel_principal_menu" align="center"> 
        
        <h4 style={{paddingBottom: '2%'}}>Ocorrencias Não Avaliadas | MONITORAMENTO DE ENTREGAS</h4>
        
        <ListaOcorrenciaAvaliacao lista={dadosOcorrencias} onAtualizarLista={carregaListaOcorrencias}/>

      </div>

    </div>

  );
};

export default Ocorrencia;